/* eslint-disable import/prefer-default-export */
import { getMyNetworkingByKey } from '../myNetworkingSelectors';
import { appendId } from '../myNetworkingUtils';
import { QUESTIONSETS_SELECTOR_KEY } from './questionsetsConstants';

export const getQuestionsetsById = (questionsetsIds) => {
  const selectorKey = appendId(QUESTIONSETS_SELECTOR_KEY, questionsetsIds);
  return getMyNetworkingByKey(selectorKey) ?? {};
};
